exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.cta_decorator__cta-btn--J29Sw {\n\twidth: 100%;\n\theight: 100%;\n\tbackground: transparent;\n\tbackground-color: transparent;\n\tborder: 0;\n\tfont-size: inherit;\n\tmargin: 0;\n\tpadding: 0;\n}\n", ""]);

// exports
exports.locals = {
	"cta-btn": "cta_decorator__cta-btn--J29Sw"
};